/**
 * Format a checkpoint criteria_prefix ('en') value for display (sentence case).
 *
 * Per Checkpoint — Identity & uniqueness (display form, Eric's decision 2026-10-09):
 * criteria_prefix['en'] is rendered in sentence case — Can, Does, Demonstrated,
 * Proved — regardless of the casing in which it is stored or returned. This is a
 * presentation-only concern and is also used to canonicalize what the frontend
 * writes so no frontend path persists a lowercase prefix (ER-12224). Backend
 * normalization to the uppercase closed set is handled separately (ER-12225).
 *
 * @param {unknown} value
 * @returns {string}
 */
export function formatCriteriaPrefix(value) {
  if (value == null) return "";
  const normalized = String(value).trim().toLowerCase();
  if (!normalized) return "";
  return normalized.charAt(0).toUpperCase() + normalized.slice(1);
}
